import { RelayEnvironment } from '@jump-tech-frontend/relay/shared';
import { ConsoleApiName } from '@datadog/browser-core';

const environmentName = 'staging';

const coreApiUrlRoot = `https://api.${environmentName}.jumptech.co.uk`;

const apiDomains = ['jumptech.co.uk', 'jt.eco'];
const domain = window.location.hostname.split(`${environmentName}.`).pop();
const relayApiUrlRoot = apiDomains.includes(domain) ? `https://api.${environmentName}.${domain}` : coreApiUrlRoot;
const relayApiUrlBase = `${relayApiUrlRoot}/relay`;
const apiEcoRoot = `https://api.${environmentName}.jt.eco`;

export const environment: RelayEnvironment = {
  production: false,
  name: environmentName,
  apiFormBase: `${coreApiUrlRoot}/tenants`,
  apiGetListUrl: `${coreApiUrlRoot}/tenant-settings/list`, // NB no relay offset
  apiOcrRekognitionUrl: `${coreApiUrlRoot}/core/recognise`,
  apiGetTranslationUrl: `${coreApiUrlRoot}/i18n`,
  apiImageAnalysisUrl: `${apiEcoRoot}/relay/proxy/image-analysis`,
  relayFormUrl: `${relayApiUrlBase}/project`,
  relaySupportUrl: `${relayApiUrlBase}/project/support`,
  relayCardUrl: `${relayApiUrlBase}/project/cards`,
  apiProjectParamsUrl: `${relayApiUrlBase}/project/parameters`,
  apiRelayProgressUrl: `${relayApiUrlBase}/progress`,
  apiRelayTrackingUrl: `${relayApiUrlBase}/tracking`,
  datadog: {
    site: 'datadoghq.eu',
    service: 'relay',
    env: 'staging',
    clientToken: 'pub56426760f06fa5255c1fcf8cae7f5e53',
    clientTokenLogging: 'pubb9a96b2274aaf35492ce895d16503d28',
    applicationId: '880d79fb-a3ac-425e-8639-ac098d552210',
    sampleRate: 100,
    replaySampleRate: 0,
    actionNameAttribute: 'data-qa',
    trackInteractions: false,
    trackingConsent: 'not-granted',
    forwardConsoleLogs: [ConsoleApiName.error]
  },
  staticDistribution: 'https://static.staging.jt.eco'
};
